import Avatar from './avatar.gjs';
import Component from '@glimmer/component';
import styles from './contact-list-item.module.scss';

export default class ContactListItem extends Component {
  get contacts() {
    let { couple } = this.args.contact;
    return couple?.length ? couple : [this.args.contact];
  }

  get userNames() {
    return this.contacts.map(user => user.name).join(' & ');
  }

  <template>
    <li
      class="{{styles.component}} contact-list-item"
      data-test-contact={{@contact.id}}
      data-test-contact-list-item
      role="button"
    >
      <Avatar @users={{this.contacts}} />
      <div class="item-details">
        <div class="top-line">
          <span class="user-names" data-test-user-names>{{this.userNames}}</span>
        </div>
      </div>
    </li>
  </template>
}
